export enum FEATURE_GATES {
  GALLERY_QUICK_VIEW_MODAL_ENABLED = 'gallery_quick_view_modal_enabled',
  GALLERY_COLOR_PERSONALIZATION = 'gallery_color_personalization',
  GALLERY_PRICE_IN_HEADER = 'fy27q1_priceinheadergallery',
}
